import Vue from "vue";
import Router from "vue-router";
import Overview from "./views/Overview";
import DataCreativeIndustry from "./views/DataCreativeIndustry";
import ResearchAndReport from "./views/ResearchAndReport";
import DeveloperPage from "./views/DeveloperPage";
import developerDetail from "./views/DeveloperDetailPage";

import AboutPage from "./views/AboutPage";
import ArticleDetailPage from "./views/ArticleDetailPage";
import PreviewChartExportDialog from "./components/PreviewChartExportDialog";
import Search from "./views/Search";

import Page404 from "./views/Page404";
import ComingSoon from "./views/ComingSoon";
import Home from "./views/Home";
import International from "./views/International";
import Country from "./views/Country";

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/international",
      name: "international",
      component: International,
    },
    {
      path: "/country",
      name: "country",
      component: Country,
    },
    // {
    //   path: "/industry/:category",
    //   name: "industry",
    //   component: Overview,
    //   props: {
    //     overview: false,
    //   },
    // },
    {
      path: "/industry/",
      name: "industry",
      component: Overview,
      props: {
        overview: false,
      },
    },

    {
      path: "/industries",
      name: "data-creative-industry",
      component: DataCreativeIndustry,
    },
    {
      path: "/industries/:statistic_id",
      name: "data-creative-industry",
      component: DataCreativeIndustry,
      props: true,
    },
    {
      path: "/industries/:statistic_id/:industry_id",
      name: "data-creative-industry",
      component: DataCreativeIndustry,
      props: true,
    },
    {
      path: "/cindex",
      name: "creativity-index",
      component: ComingSoon, // TODO: (temporary) change it to CreativityIndex
    },
    {
      path: "/report",
      name: "research-and-report",
      component: ResearchAndReport,
    },
    {
      path: "/about",
      name: "about",
      component: AboutPage,
    },
    {
      path: "/developer",
      name: "developer",
      component: DeveloperPage,
    },
    {
      path: "/developerDetail/:id",
      name: "developerDetail",
      component: developerDetail,
    },
    {
      path: "/article/detail/:id",
      name: "articleDetail",
      component: ArticleDetailPage,
      props: true,
    },
    {
      path: "/graph-export/preview",
      name: "PreviewChartExportDialog",
      component: PreviewChartExportDialog,
    },
    {
      path: "/search/:keyword?",
      name: "Search",
      component: Search,
      props: true,
    },
    {
      path: "*",
      name: "Page404",
      component: Page404,
    },
  ],
});
